/** Gestion du thème clair/sombre, persistée en localStorage. */
const KEY = 'jhn-theme';

export function getTheme() {
  return document.documentElement.getAttribute('data-theme') || 'dark';
}

export function setTheme(t) {
  document.documentElement.setAttribute('data-theme', t);
  try { localStorage.setItem(KEY, t); } catch {}
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', t === 'light' ? '#f3efe8' : '#0a0a0a');
}

export function toggleTheme() {
  setTheme(getTheme() === 'light' ? 'dark' : 'light');
  return getTheme();
}
